import { render, staticRenderFns } from "./SlidePlayerLayout.vue?vue&type=template&id=700d64fc&scoped=true"
import script from "./SlidePlayerLayout.vue?vue&type=script&lang=ts"
export * from "./SlidePlayerLayout.vue?vue&type=script&lang=ts"
import style0 from "./SlidePlayerLayout.vue?vue&type=style&index=0&id=700d64fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d64fc",
  null
  
)

export default component.exports